module.exports = __webpack_public_path__ + "img/Device.9733e019.png";